import { call, put, select, takeLatest } from 'redux-saga/effects'
import { setCutomSignatureTypeOptions } from '../store/options.actions'
import Logger from '../../../services/logger.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { SignaturesService } from '../../signatures/services/signatures.service'
import { getServiceIdSelector } from '../../user/selectors'

export function* getCustomSignatureTypesOptions() {
  try {
    const serviceId = yield select(getServiceIdSelector)
    const signaturesService = new SignaturesService(serviceId)
    const response = yield call([signaturesService, signaturesService.getSignatureTypeOptions])
    const { entity } = response

    yield put(setCutomSignatureTypeOptions(entity))
  } catch (e) {
    Logger.error(`getCustomSignatureTypesOptions() error: ${e}`)
  }
}
export function* getCustomSignatureTypesOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getCustomSignatureTypesOptions)
}
